module.exports = __webpack_public_path__ + "img/05.36194de9.jpg";